import React from 'react';
import Guarantees from './Guarantees';
import Securities from './Securities';

const SecuritiesAndGuarantees: React.FC = () => {
    return (
        <div className="py-4">
            <p className="WorkSans font-semibold text-base" style={{ color: '#182D4F' }}>
                Securities
            </p>
            <Securities />
            <p className="WorkSans font-semibold text-base pt-4" style={{ color: '#182D4F' }}>
                Guarantees
            </p>
            <Guarantees />
        </div>
    );
};

export default SecuritiesAndGuarantees;
